import { DOCUMENT_TYPE_NAME } from './../models/User';
import { Utils } from 'src/app/pages/core/utils/Utils';
import { ITransaction, TransactionTypeString } from './../models/Transactions';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../abstraction/auth.service';
import { CryptoService } from '../abstraction/crypto.service';
import { DOCUMENT_STATUS, DOCUMENT_TYPE } from '../models/User';
import { ICharge, CHARGE_STATUS } from '../models/Commerce';
import { COIN_FULL_NAME } from '../models/Crypto';
import { WITHDRAW_TRANSACTION_STATUS, IFiatTransaction } from '../models/FiatTransaction';
import BigNumber from 'bignumber.js';
import { AuthSocketService } from './auth-socket.service';
import { AuthenticationService } from '../../auth/services/authentication.service';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';
import { hiddenCoins } from '../utils/coins.hidden';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  socketTimestamp = Date.now();

  constructor(
    public authService: AuthService,
    public authenticationService: AuthenticationService,
    public matDialog: MatDialog,
    private cryptoService: CryptoService,
    private authSocketService: AuthSocketService,
  ) {}

  connect() {
    this.authSocketService.connect();
  }

  initialize() {
    if (this.authSocketService.socket) {
      return;
    }
    this.connect();
    this.authSocketService.socket.on('pricesCrypto', (prices) => {
      this.socketTimestamp = Date.now();
      let socketPrices = prices.data;
      if (this.authService.loggedUser?.isCommerce) {
        if (socketPrices?.DAICOMM_ARS?.buy) {
          socketPrices = {
            ...socketPrices,
            DAI_ARS: {
              ...socketPrices?.DAICOMM_ARS,
              ticker: 'DAI_ARS',
              originalValue: { buy: socketPrices?.DAI_ARS?.buy, sell: socketPrices?.DAI_ARS?.sell },
            },
          };
        }
        if (socketPrices?.DAICOMM_USD?.buy) {
          socketPrices = {
            ...socketPrices,
            DAI_USD: { ...socketPrices?.DAICOMM_USD, ticker: 'DAI_USD' },
          };
        }
        if (socketPrices?.USTCOMM_ARS?.buy) {
          socketPrices = {
            ...socketPrices,
            UST_ARS: { ...socketPrices?.USTCOMM_ARS, ticker: 'UST_ARS' },
          };
        }
        if (socketPrices?.USTCOMM_USD?.buy) {
          socketPrices = {
            ...socketPrices,
            UST_USD: { ...socketPrices?.USTCOMM_USD, ticker: 'UST_USD' },
          };
        }
        if (socketPrices?.BUSDCOMM_ARS?.buy) {
          socketPrices = {
            ...socketPrices,
            BUSD_ARS: {
              ...socketPrices?.BUSDCOMM_ARS,
              ticker: 'BUSD_ARS',
            },
          };
        }
        if (socketPrices?.BUSDCOMM_USD?.buy) {
          socketPrices = {
            ...socketPrices,
            BUSD_USD: {
              ...socketPrices?.BUSDCOMM_USD,
              ticker: 'BUSD_USD',
            },
          };
        }
        if (socketPrices?.USDCCOMM_ARS?.buy) {
          socketPrices = {
            ...socketPrices,
            USDC_ARS: {
              ...socketPrices?.USDCCOMM_ARS,
              ticker: 'USDC_ARS',
            },
          };
        }
        if (socketPrices?.USDCCOMM_USD?.buy) {
          socketPrices = {
            ...socketPrices,
            USDC_USD: {
              ...socketPrices?.USDCCOMM_USD,
              ticker: 'USDC_USD',
            },
          };
        }
        if (socketPrices?.NUARSCOMM_ARS?.buy) {
          socketPrices = {
            ...socketPrices,
            NUARS_ARS: { ...socketPrices?.NUARSCOMM_ARS, ticker: 'NUARS_ARS' },
          };
        }
        if (socketPrices?.NUARSCOMM_USD?.buy) {
          socketPrices = {
            ...socketPrices,
            NUARS_USD: { ...socketPrices?.NUARSCOMM_USD, ticker: 'NUARS_USD' },
          };
        }
      }
      if (socketPrices?.LUNA_ARS?.buy) {
        socketPrices = {
          ...socketPrices,
          LUNC_ARS: { ...socketPrices?.LUNA_ARS, ticker: 'LUNC_ARS', coin: 'LUNC_ARS' },
        };
      }
      if (socketPrices?.LUNA_USD?.buy) {
        socketPrices = {
          ...socketPrices,
          LUNC_USD: { ...socketPrices?.LUNA_USD, ticker: 'LUNC_USD', coin: 'LUNC_USD' },
        };
      }
      if (socketPrices?.LUNA_DAI?.buy) {
        socketPrices = {
          ...socketPrices,
          LUNC_DAI: { ...socketPrices?.LUNA_DAI, ticker: 'LUNC_DAI', coin: 'LUNC_DAI' },
        };
      }
      if (socketPrices?.UST_ARS?.buy) {
        socketPrices = {
          ...socketPrices,
          USTC_ARS: { ...socketPrices?.UST_ARS, ticker: 'USTC_ARS', coin: 'USTC_ARS' },
        };
      }
      if (socketPrices?.UST_USD?.buy) {
        socketPrices = {
          ...socketPrices,
          USTC_USD: { ...socketPrices?.UST_USD, ticker: 'LUNC_USD', coin: 'LUNC_USD' },
        };
      }
      if (socketPrices?.USDT_DAI?.buy) {
        socketPrices = {
          ...socketPrices,
          USTC_DAI: { ...socketPrices?.UST_DAI, ticker: 'USTC_DAI', coin: 'USTC_DAI' },
        };
      }
      if (socketPrices?.LUNA2_ARS?.buy) {
        socketPrices = {
          ...socketPrices,
          LUNA_ARS: { ...socketPrices?.LUNA2_ARS, ticker: 'LUNA_ARS', coin: 'LUNA_ARS' },
        };
      }
      if (socketPrices?.LUNA2_USD?.buy) {
        socketPrices = {
          ...socketPrices,
          LUNA_USD: { ...socketPrices?.LUNA2_USD, ticker: 'LUNA_USD', coin: 'LUNA_USD' },
        };
      }
      let newPrices = this.cryptoService.prices.value;
      // Si en socketPrices es Undefined, busca setear un valor con newPrices
      if (!socketPrices?.LUNA2_USD?.buy && newPrices?.LUNA2_USD) {
        socketPrices = {
          ...socketPrices,
          LUNA_USD: { ...newPrices?.LUNA2_USD, ticker: 'LUNA_USD', coin: 'LUNA_USD' },
        };
      }
      newPrices = {
        ...newPrices,
        ...socketPrices,
      };
      this.cryptoService.prices.next(newPrices);
    });

    this.authSocketService.socket.on('cryptoDepositReceived', (tx: ITransaction) => {
      this.authService.updateTransactionToActivities(tx);
    });

    this.authSocketService.socket.on('cryptoDepositConfirmed', (tx: ITransaction) => {
      // console.log('CRYPTO_DEPOSIT_CONFIRMED', tx);
      if (hiddenCoins.includes(tx.coin)) return;

      this.authService.updateTransactionToActivities(tx);
      this.cryptoService.updateTransactionToPortfolio(tx, TransactionTypeString.DEPOSIT);
      if (tx.from === '0xa88f86E5685FCa7C5D6de0e4D944875b007137b5') {
        this.matDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: 'Depósito rechazado',
            content: `No se admiten depósitos de BingX, sus fondos serán devueltos a la wallet de origen.`,
            isError: true,
          },
        });
      } else {
        this.matDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title: '¡Depósito acreditado!',
            content: `Tu depósito de ${tx.amount} ${tx.coin} se acreditó con éxito. Ya podés ver tu nuevo saldo en tu portfolio.`,
            tick: true,
          },
        });
      }
    });

    this.authSocketService.socket.on('cryptoWithdrawReceived', (tx: ITransaction) => {
      this.authService.updateTransactionToActivities(tx);
    });

    this.authSocketService.socket.on('cryptoWithdrawConfirmed', (tx: ITransaction) => {
      this.authService.updateTransactionToActivities(tx);
      this.matDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: '¡Retiro completado!',
          content: `Tu retiro de ${tx.amount} ${tx.coin} se ha completado con éxito. Ya podés ver tu nuevo saldo en el portfolio.`,
          tick: true,
        },
      });
    });

    this.authSocketService.socket.on('cryptoWithdrawCancelled', (tx: ITransaction) => {
      this.authService.updateTransactionToActivities(tx);
      this.cryptoService.updateTransactionToPortfolio(tx, TransactionTypeString.WITHDRAW);
    });

    this.authSocketService.socket.on('newWithdrawStatus', (withdraw: IFiatTransaction) => {
      this.authService.updateWithdrawToActivities(withdraw);
      if (
        withdraw.status === WITHDRAW_TRANSACTION_STATUS.CANCELLED ||
        withdraw.status === WITHDRAW_TRANSACTION_STATUS.FAILED
      ) {
        this.authService.refundWithdrawBalance(withdraw);
      }
    });

    this.authSocketService.socket.on('depositDone', (deposit) => {
      this.authService.addDepositTxToHistory(deposit);
    });

    this.authSocketService.socket.on('dniValidation', (data: any) => {
      if (data.dnis) this.authService.loggedUser.dnis = data.dnis;
      const pathname = window.location.pathname;
      if (pathname.split('/')[2] !== 'w-signup') {
        if (data.accepted) {
          if (data.dnis.front === 3 && data.dnis.back === 3) {
            this.authService.getMe();
            if (
              !this.authService.loggedUser.data.isPEP &&
              !this.authService.loggedUser.data.isUIF
            ) {
              this.matDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
                panelClass: 'modal-container',
                data: {
                  title: 'Cuenta validada',
                  content: 'La validación de DNI fue aceptada. Ya podés empezar a operar.',
                  isError: true,
                },
              });
            }
          }
        } else {
          this.matDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'Error de validación',
              content:
                'La validación de DNI fue rechazada. Por favor, volvé a subir las imágenes correctamente.',
              isError: true,
            },
          });
        }
      }
    });

    this.authSocketService.socket.on(
      'fundsValidation',
      (data: { accepted: boolean; amount: number; comment: string }) => {
        let title = 'Origen de fondo aceptado';
        const comment = data.comment.length > 0 ? `<br><br><b>Comentario: </b>${data.comment}` : '';
        let message = `Se ha validado tu origen de fondos. Tu límite ha aumentado en ARS ${Utils.roundNumber(
          +data.amount,
        ).toFixed(2)}.${comment}`;
        if (data.accepted && +data.amount === 0) {
          // Si el fund fue aceptado pero sin aumentar limite
          message = `Tu documentación es correcta pero no pudimos aumentar tu límite de operación. Si tenés alguna duda contactanos por el chat${comment}`;
        } else if (!data.accepted) {
          // Si el fund fue rechazado
          title = 'Origen de fondo rechazado';
          message = `La validación de tu origen de fondos ha sido rechazada.<br><br><b>Motivo del rechazo</b>: ${data.comment}`;
        }
        this.authService.getMe();
        this.matDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
          panelClass: 'modal-container',
          data: {
            title,
            content: message,
          },
        });
      },
    );

    this.authSocketService.socket.on(
      'companyDocValidation',
      (data: { docType: DOCUMENT_TYPE; accepted: boolean }) => {
        this.authService.setDocumentStatus(
          data.docType,
          data.accepted ? DOCUMENT_STATUS.VALIDATED : DOCUMENT_STATUS.REJECTED,
        );
        let title;
        let message;

        if (this.authService.hasValidatedCompanyDocuments()) {
          title = 'Cuenta validada';
          message =
            'La validación de las documentaciones requeridas fueron aceptadas. Ya podés empezar a operar.';
        } else if (!data.accepted) {
          title = 'Error de validación';
          message = `La validación de ${
            DOCUMENT_TYPE_NAME[data.docType]
          } fue rechazada. Por favor, volvé a subir las documentaciones correctamente.`;
        }
        if (title && message) {
          this.matDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title,
              content: message,
            },
          });
        }
      },
    );

    this.authSocketService.socket.on('payrollReceived', (res) => {
      const title = 'Pago de Sueldo';
      const message = `Se te han depositado ${res.salary} ${res.coin}. Ya podés ver tu nuevo saldo en tu portfolio.`;

      this.matDialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title,
          content: message,
        },
      });
      this.authService.getUserHistories().subscribe();
    });

    this.authSocketService.socket.on(
      'chargeStatusChange',
      (res: { newState: CHARGE_STATUS; chargeId: string; charge: ICharge }) => {
        const { newState, chargeId, charge } = res;
        const { result, page } = this.cryptoService.getCharges().getValue();
        const chargeFeePercent = (this.authService.commerceConfig.getValue()?.fee || 0) / 100;

        if (newState !== CHARGE_STATUS.NEW) {
          const isRefund =
            newState === CHARGE_STATUS.REFUNDED || newState === CHARGE_STATUS.REFUND_ERRORED;
          //ACTUALIZAR ESTADÍSTICAS
          if (
            newState === CHARGE_STATUS.COMPLETED ||
            newState === CHARGE_STATUS.RESOLVED ||
            isRefund
          ) {
            const prices = this.cryptoService.prices.value;
            const chargesStats = this.cryptoService.getChargesStats().getValue();
            let prevChargeAmount = +charge.price.amount;
            const lastPayment = charge.payments[charge.payments.length - 1];

            //Obtener anterior "ultimo pago"
            if (isRefund) {
              if (page === 1) {
                const prevChargeAmountFound = result.charges.filter(
                  ({ status, id }) => status === CHARGE_STATUS.COMPLETED && id !== chargeId,
                )[0]?.price.amount;
                prevChargeAmount = prevChargeAmountFound ? +prevChargeAmountFound : 0;
              }
            }

            const originalStablePrice =
              (isRefund ? -1 : 1) *
              +charge.pricing.find((price) => price.currency === lastPayment.coin)?.amount;

            chargesStats.lastPaymentCurrency = charge.price.currency;
            chargesStats.lastPaymentAmount = isRefund ? prevChargeAmount : +charge.price.amount;
            chargesStats.paymentsInTimeframeSum += originalStablePrice;
            if (chargesStats.timeFrame === 'DAILY') {
              if (isRefund) {
                chargesStats.statsInDivision[new Date(charge.timeline.pop().time).getHours()] +=
                  originalStablePrice;
              } else {
                chargesStats.statsInDivision[new Date().getHours()] += originalStablePrice;
              }
            } else {
              chargesStats.statsInDivision[chargesStats.statsInDivision.length - 1] +=
                originalStablePrice;
            }

            //ACTUALIZAR BALANCES CRYPTO/FIAT
            const portfolio = this.authService.myCryptoPortfolio.getValue();
            const prevBalanceIndex = portfolio.findIndex((coin) => {
              return coin.ticker === lastPayment.coin;
            });
            const lastPaymentAmount = new BigNumber(lastPayment.value.human).multipliedBy(
              isRefund ? -1 : 1,
            );
            const chargeFee = chargeFeePercent * lastPaymentAmount.toNumber();

            const sellPriceUsd = new BigNumber(prices[lastPayment.coin + '_USD'].sell);
            const sellPriceArs = new BigNumber(prices[lastPayment.coin + '_ARS'].sell);

            const balanceUsd = lastPaymentAmount.minus(chargeFee).multipliedBy(sellPriceUsd);
            const balanceArs = lastPaymentAmount.minus(chargeFee).multipliedBy(sellPriceArs);

            if (prevBalanceIndex !== -1) {
              portfolio[prevBalanceIndex].balance = new BigNumber(
                portfolio[prevBalanceIndex].balance,
              )
                .plus(balanceUsd)
                .toString();
              portfolio[prevBalanceIndex].totalInvested += balanceUsd.toNumber();
              portfolio[prevBalanceIndex].balanceArs = new BigNumber(
                portfolio[prevBalanceIndex].balanceArs,
              )
                .plus(balanceArs)
                .toString();
              portfolio[prevBalanceIndex].totalARSinvested += balanceUsd.toNumber();
              portfolio[prevBalanceIndex].stocks = new BigNumber(portfolio[prevBalanceIndex].stocks)
                .plus(lastPaymentAmount)
                .minus(chargeFee)
                .toString();

              const userBalance: { amount: string } =
                this.authService.loggedUser.balance.crypto[lastPayment.coin];
              const userBalanceAmount = new BigNumber(userBalance.amount);
              const newAmount = userBalanceAmount.plus(lastPaymentAmount).minus(chargeFee);
              this.authService.loggedUser.balance.crypto[lastPayment.coin].amount =
                newAmount.toString();
            } else {
              portfolio.push({
                ticker: lastPayment.coin,
                name: COIN_FULL_NAME[lastPayment.coin],
                price: sellPriceArs.toString(),
                porcentage: 0,
                stocks: lastPaymentAmount.minus(chargeFee).toString(),
                balance: balanceUsd.toString(),
                balanceArs: balanceArs.toString(),
                stakeBalance: 0,
                totalInvested: balanceUsd.toNumber(),
                totalARSinvested: balanceArs.toNumber(),
                capitalChange: 0,
                capitalChangeP: 0,
                histories: [],
              });

              this.authService.loggedUser.balance.crypto[lastPayment.coin] = {
                ...this.authService.loggedUser.balance.crypto[lastPayment.coin],
                amount: lastPaymentAmount.minus(chargeFee).toString(),
              };
            }

            this.authService.myCryptoPortfolio.next(portfolio);
            this.cryptoService.prices.next(this.cryptoService.prices.value); //Forzar actualizacion
            this.cryptoService.getChargesStats().next(chargesStats);
          }

          //Actualizar charge de la lista de charges
          result.charges = result.charges.map((currentCharge) => {
            if (currentCharge.id === chargeId) {
              return charge;
            }
            return currentCharge;
          });
          this.cryptoService.getCharges().next({ result, page });
        } else if (page === 1) {
          //Agregar el nuevo charge solo si estan en la pagina 1
          result.charges = result.charges.reverse();
          result.charges.push(charge);
          result.totalCount += 1;
          result.charges = result.charges.reverse();
          this.cryptoService.getCharges().next({ result, page });
        }
      },
    );

    this.authSocketService.socket.on('emailConfirmed', (data) => {
      this.authService.loggedUser.flags.mailConfirmed = data.status;
    });
  }
}
